var map = {
	"./airPurifiers_0.png": "843c",
	"./airPurifiers_0_0.png": "e350",
	"./airPurifiers_0_1.png": "8812",
	"./airPurifiers_1.png": "a738",
	"./airPurifiers_1_0.png": "2281",
	"./airPurifiers_1_1.png": "2175",
	"./airPurifiers_up.png": "c2c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1019";